import React from 'react';
import { formatNumberLegacy } from '../../../CommonUtils/formatNumberLegacy';
import { Panel, Title, Row } from './RothConversionStyles';
import { RothConversionProps } from './RothConversionTypes';

const SUMMARY_LINE_DESCRIPTION = {
  pretax: 'Tax Deferred',
  taxFree: 'Tax Free',
  taxable: 'Taxable',
  totalAssets: 'Total Assets',
  totalRMDs: 'Total RMDs',
  totalTaxesPaid: 'Total Taxes Paid',
};

export const RothConversionTable: React.FC<RothConversionProps> = ({ maxTaxBracket, summary }) => {
  return (
    <Panel>
      <Title>Roth Conversion</Title>
      <div>
        Tax Bracket &nbsp;
        {maxTaxBracket && (
          <>
            <span style={{ color: maxTaxBracket.color }}>&#9679;</span>
            {maxTaxBracket.value}%
          </>
        )}
      </div>
      <Row bottomBordered>
        <div />
        <div style={{ fontWeight: 600 }}>
          <span style={{ color: '#BADFEF' }}>&#9679;</span> Current
        </div>
        <div style={{ fontWeight: 600 }}>
          <span style={{ color: '#5090DE' }}>&#9679;</span> Proposed (With Conversion)
        </div>
        <div style={{ fontWeight: 600 }}>Difference</div>
      </Row>
      {Object.entries(summary).map(([k, { recommended, current, difference }]) => (
        <Row
          key={k}
          bottomBordered={['taxable', 'totalAssets'].includes(k)}
          bold={k === 'totalAssets'}
        >
          <div style={{ textAlign: 'left' }}>{SUMMARY_LINE_DESCRIPTION[k]}</div>
          <div>{formatNumberLegacy(current, { type: 'currency' })}</div>
          <div>{formatNumberLegacy(recommended, { type: 'currency' })}</div>
          <div style={{ color: difference < 0 ? 'red' : 'inherit' }}>
            {formatNumberLegacy(Math.abs(difference || 0), { type: 'currency' })}
          </div>
        </Row>
      ))}
    </Panel>
  );
};
